// extracted by mini-css-extract-plugin
module.exports = {"swiperWrapper":"swiper_swiperWrapper__UnUWE","featuresSwiper":"swiper_featuresSwiper__2Fjvv"};